/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IBasicFeeHandler,
  IBasicFeeHandlerInterface,
} from "../IBasicFeeHandler";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
    ],
    name: "_domainResourceIDToFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export class IBasicFeeHandler__factory {
  static readonly abi = _abi;
  static createInterface(): IBasicFeeHandlerInterface {
    return new utils.Interface(_abi) as IBasicFeeHandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IBasicFeeHandler {
    return new Contract(address, _abi, signerOrProvider) as IBasicFeeHandler;
  }
}
